import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";
import { ContentLayout } from "@/components/Layout/ContentLayout";
import { Language } from "@/components/Settings/Languages/LanguagesDropdown";
import { TranslationsApiFilters, TranslationsFilter } from "@/components/Settings/Translations/TranslationsFilter";
import { TranslationsTable } from "@/components/Settings/Translations/TranslationsTable";
import { useSeller } from "@/hooks/useAccount";
import { useCollection } from "@/hooks/useCollection";
import { Page } from "@/pages/Page";

export const TranslationsPage = () => {
    const { locale } = useParams<{ locale: string }>();
    const seller = useSeller();
    const history = useHistory();
    const [filters, setFilters] = useState<TranslationsApiFilters>({
        seller: seller.id,
        locale,
        tag: [],
        ancestors: [],
    });

    const handleBreadcrumbClick = (url: string) => () => {
        history.push(url);
    };

    const { data: languages } = useCollection<Language, "locale">(["languages"]);
    const translationLanguage = languages.find((language) => language.locale === locale);

    return (
        <Page title="Translations">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="flex-grow border-r-0">
                        <Breadcrumb.Item onClick={handleBreadcrumbClick("/settings/languages")}>
                            Translations
                        </Breadcrumb.Item>
                        {translationLanguage && <Breadcrumb.Item>{translationLanguage.language}</Breadcrumb.Item>}
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    {(height) => (
                        <ContentLayout isWide className="space-y-4" classNames={{ root: "mb-0" }}>
                            <TranslationsFilter filters={filters} setFilters={setFilters} />
                            <TranslationsTable height={height} filters={filters} locale={locale} />
                        </ContentLayout>
                    )}
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
